'use client'

import { useTranslations } from 'next-intl'

import { cn } from '@/lib/utils/cn'

import { SKILL_CLOUD } from './company-data'

export function SkillCloudCard() {
  const t = useTranslations('company')

  return (
    <div className="logo-card">
      <p className="logo-card__cap">{t('brand.openSkill')}</p>
      <div className="logo-cloud">
        {SKILL_CLOUD.map((skill, index) => (
          <span
            key={skill.nameKey}
            className={cn(
              'logo-chip',
              skill.kind === 'core' ? 'is-core' : 'is-sat',
              skill.kind === 'core' && skill.ring && `is-${skill.ring}`
            )}
            style={{
              ['--x' as string]: skill.x,
              ['--y' as string]: skill.y,
              animationDelay: `${index * 160}ms`
            }}
          >
            {t(`careers.skills.${skill.nameKey}`)}
          </span>
        ))}
      </div>
    </div>
  )
}
